module.exports = __webpack_public_path__ + "static/portfolio-mas-1-008b8c67d34fca1f484b0073e14830a5.jpg";